export const EVENT_ALERT_KIND = 'event_alert';
export const CMP_CONNECTION_EVENT_KIND = 'cmp_connection_event';
export const CUSTOM_FUNCTION_ACTION_RESULT_KIND =
  'custom_function_action_result';
export const DEVICE_CONNECTION_EVENT_CODE = 1048267;

export const EVENT_LOG_KIND_OPTIONS = [
  { label: 'All log kinds', value: 'all' },
  { label: 'Event alerts', value: EVENT_ALERT_KIND },
  {
    label: 'Custom function results',
    value: CUSTOM_FUNCTION_ACTION_RESULT_KIND,
  },
];

export function isCustomFunctionResultLog(log = {}) {
  return log?.kind === CUSTOM_FUNCTION_ACTION_RESULT_KIND;
}

export function isCmpConnectionLog(log = {}) {
  return (
    log?.kind === CMP_CONNECTION_EVENT_KIND ||
    Number(log?.eventType ?? log?.code ?? NaN) === DEVICE_CONNECTION_EVENT_CODE
  );
}

export function getCmpConnectionStatusLabel(triggered) {
  return triggered ? 'Offline' : 'Online';
}

export function getCmpConnectionStatusColor(triggered) {
  return triggered ? 'maroon' : 'forestgreen';
}

export function getCmpConnectionCurrentStateNote(log = {}) {
  if (log?.triggered === true && log?.connectionState === 'Connected') {
    return 'Device is currently online.';
  }
  if (log?.triggered === false && log?.connectionState === 'Disconnected') {
    return 'Device is currently offline.';
  }
  return '';
}

export function getCustomFunctionStatusLabel(status) {
  switch (status) {
    case 'succeeded':
      return 'Succeeded';
    case 'failed':
      return 'Failed';
    case 'launch_failed':
      return 'Launch Failed';
    case 'timed_out':
      return 'Timed Out';
    default:
      return status || 'Completed';
  }
}

export function getCustomFunctionStatusColor(status) {
  switch (status) {
    case 'succeeded':
      return 'forestgreen';
    case 'failed':
    case 'launch_failed':
    case 'timed_out':
      return 'maroon';
    default:
      return '#666';
  }
}

export function getCustomFunctionOperationLabel(status) {
  const label = getCustomFunctionStatusLabel(status);
  return `Custom Function ${label}`.trim();
}

export function buildCustomFunctionDescription(log = {}) {
  const parts = [];

  if (log.actionName) {
    parts.push(log.actionName);
  }
  if (log.scriptName && log.scriptName !== log.actionName) {
    parts.push(log.actionName ? `script ${log.scriptName}` : log.scriptName);
  }
  if (log.actionStatus) {
    parts.push(getCustomFunctionStatusLabel(log.actionStatus).toLowerCase());
  }
  if (typeof log.exitCode === 'number') {
    parts.push(`exit code ${log.exitCode}`);
  }
  if (typeof log.signal === 'number') {
    parts.push(`signal ${log.signal}`);
  }
  if (log.errorMessage) {
    parts.push(log.errorMessage);
  }

  return parts.join(' • ');
}
